import React from 'react';
import Link from 'next/link';
import { Container, Row, Col, Button } from 'react-bootstrap';
import { FaShieldHalved, FaMagnifyingGlass, FaArrowRight, FaBolt } from 'react-icons/fa6';
import { FaCheckCircle } from 'react-icons/fa';
import { useRouter } from 'next/router';

export default function CtaBanner({ code }) {
  const router = useRouter();
  return (
    <section className="cta-banner-section bg-light-subtle">
      <Container className="py-2 py-lg-4">
        <div
          className="text-white rounded-5 p-4 p-md-5 shadow-lg position-relative overflow-hidden"
          style={{
            background: 'linear-gradient(135deg, #0f172a 0%, #1e40af 50%, #1d4ed8 100%)'
          }}
        >
          <Row className="justify-content-center text-center position-relative" style={{ zIndex: 2 }}>
            <Col lg={9} xl={8}>
              <span className="badge bg-white text-primary rounded-pill px-3 py-2 text-uppercase fw-bold mb-3 fs-7 shadow-sm d-inline-flex align-items-center gap-2">
                <FaShieldHalved size={14} /> Proteja o Seu Investimento
              </span>

              <h2 className="display-6 fw-extrabold text-white mb-3">
                Pronto para fazer uma negociação veicular 100% segura?
              </h2>

              <p className="text-white mb-4 fs-5 mx-auto lh-base" style={{ maxWidth: '640px' }}>
                Consulte o histórico completo de qualquer veículo por placa em segundos. Evite surpresas desagradáveis com leilão, sinistro, débitos ou restrições.
              </p>

              <div className="d-flex flex-column flex-sm-row justify-content-center align-items-center gap-3 mb-4">
                <Button
                  size="lg"
                  className="fw-bold px-4 py-3 rounded-pill text-white border-2 d-inline-flex align-items-center gap-2 fs-6"
                  onClick={() => router.push(`/consulta/rapida/${code ?? 'completa'}`)}
                >
                  <FaMagnifyingGlass size={16} />
                  <span>Consultar Placa Agora</span>
                </Button>
                <Button
                  variant="light"
                  size="lg"
                  className="fw-bold px-4 py-3 rounded-pill text-primary shadow-lg border-0 d-inline-flex align-items-center gap-2 fs-6 hover-elevation transition-all"
                  onClick={() => router.push('/consultas-e-pacotes')}
                >
                  <span>Ver Consultas e Pacotes</span>
                  <FaArrowRight size={16} />
                </Button>
              </div>

              <div className="d-flex flex-wrap justify-content-center gap-3 text-white small fw-medium">
                <span className="d-inline-flex align-items-center gap-1">
                  <FaCheckCircle className="text-warning" size={14} /> Sem mensalidade
                </span>
                <span className="d-inline-flex align-items-center gap-1">
                  <FaBolt className="text-warning" size={14} /> Resultado instantâneo
                </span>
                <span className="d-inline-flex align-items-center gap-1">
                  <FaCheckCircle className="text-warning" size={14} /> Pagamento 100% seguro
                </span>
              </div>
            </Col>
          </Row>
        </div>
      </Container>
    </section >
  );
}
